import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export default function () {
    const contactTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: '[data-block="contact"]',
            start: 'top center',
            scrub: false,
            once: true
        }
    })

    if (!document.querySelector('[data-block="contact"]'))
        return contactTimeline

    contactTimeline.from('[data-block="contact-background"]', { scaleY: 0, transformOrigin: '100% 100%', ease: "cubic", duration: 1.2 })
        .from('[data-block="contact-heading"]', { opacity: 0, y: 40 }, '>')
        .from('[data-block="contact-content"] > p', { opacity: 0, y: 40 }, '+=.4')
        .from('[data-block="contact-content"] > aside', { opacity: 0, y: -40 }, '<')
        .from('[data-block="contact"] form', { opacity: 0 }, '+=.4')

    const contactFormTimeline = gsap.timeline({
        paused: true
    })

    contactFormTimeline.fromTo('[data-block="contact-form-result"]', { scale: 0 }, { scale: 1, transformOrigin: '50% 100%', ease: "cubic", duration: 1.2 })
        .fromTo('.hf-form', { opacity: 1 }, { opacity: 0, immediateRender: false }, '-=.8')
        .fromTo('[data-block="contact-form-result"] > span', { opacity: 0, y: 40 }, { opacity: 1, y: 0 }, '-=.4')


    window.hasOwnProperty('html_forms') && window.html_forms.on('success', () => contactFormTimeline.play())

    const result = document.querySelector('[data-block="contact-form-result"]')
    result.querySelector('span').innerHTML = document.querySelector('.hf-form').dataset.messageSuccess
    result.addEventListener('click', () => contactFormTimeline.reverse())

    const mapTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: '[data-block="contact-map"]',
            start: 'bottom bottom',
            scrub: false,
            once: true
        }
    })

    mapTimeline.from('[data-block="contact-map"] > div', { yPercent: 100, ease: "cubic", duration: 1.6 })
        .from('[data-block="footer"]', { scaleY: 0, transformOrigin: '0 0', ease: "cubic", duration: 1.2 }, '<+=.4')
        .from('[data-block="marquee"]', { opacity: 0 }, '>')

    gsap.from('[data-block="footer-content"]', {
        opacity: 0,
        y: 32,
        stagger: .12,
        scrollTrigger: {
            trigger: '[data-block="footer-content"]:not(figure)',
            start: 'center bottom',
            scrub: false,
            once: true
        }
    })

    ScrollTrigger.isInViewport('[data-block="contact-map"]') ? loadMap()
        : ScrollTrigger.create({
            trigger: '[data-block="contact"]',
            start: 'top bottom',
            once: true,
            onEnter: (self) => loadMap()
        })

    const insertBefore = document.head.insertBefore;
    document.head.insertBefore = (newElement, referenceElement) => {
        !isRobotoStyle(newElement) && insertBefore.call(document.head, newElement, referenceElement);
    };

    const appendChild = document.head.appendChild;
    document.head.appendChild = (newElement) => {
        !isRobotoStyle(newElement) && appendChild.call(document.head, newElement);
    };

    return contactTimeline
}

const loadMap = () => {
    const gMapsJs = document.createElement('script')
    gMapsJs.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA_IckNle5OAQHtUqaSKFQHDtGe9nmJj_0&callback=initMap&loading=async&libraries=&v=weekly`

    window.initMap = initMap
    document.body.insertAdjacentElement('beforeend', gMapsJs)
}

const initMap = () => {
    const mapEl = document.querySelector('[data-block="contact-map"] > div')
    if (!mapEl) return

    const officeAddress = {lat: 50.0906855565402, lng: 14.436661999898396 }
    const mapOffice = new google.maps.Map(mapEl, {
        center: officeAddress,
        zoom: 16,
        disableDefaultUI: true,
        styles: [
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-49"
                    },
                    {
                        "lightness": "10"
                    },
                    {
                        "hue": "#ff8400"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels",
                "stylers": [
                    {
                        "saturation": "-40"
                    },
                    {
                        "visibility": "simplified"
                    },
                    {
                        "hue": "#ff5c00"
                    },
                    {
                        "gamma": "1"
                    },
                    {
                        "lightness": "16"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d1d1c3"
                    }
                ]
            },
            {
                "featureType": "landscape.natural.terrain",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#9babb0"
                    }
                ]
            },
            {
                "featureType": "poi.attraction",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.government",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.medical",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.place_of_worship",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.school",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.sports_complex",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "color": "#e6e6d3"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "saturation": "-23"
                    },
                    {
                        "gamma": "2.01"
                    },
                    {
                        "color": "#c3c3b4"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "saturation": "-14"
                    },
                    {
                        "color": "#c3c3b4"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "color": "#8a8a78"
                    }
                ]
            }
        ]
    });

    const marker = new google.maps.Marker({
        position: officeAddress,
        icon: 'wp-content/themes/sustainavision/resources/icons/symbol.svg',
        map: mapOffice
    });

    mapOffice.addListener("tilesloaded", () => mapEl.classList.remove('is-loading'))
}

const isRobotoStyle = (element) => {
    // roboto font download
    if (element.href && element.href.indexOf('https://fonts.googleapis.com/css?family=') === 0) {
        return true;
    }

    // when google tries to add empty style
    return element.tagName.toLowerCase() === 'style' && !element.styleSheet && !element.innerHTML;
}